import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { loadInvitation } from '../api/acceptInvitationLoad'
import { confirmInvitation } from '../api/acceptInvitationConfirm'
import { apiRequest } from '../utils/apiRequest'

export function useAcceptInvitation() {
  const location = useLocation()
  const invitationToken = new URLSearchParams(location.search).get(
    'invitation_token',
  )

  const [state, setState] = useState({
    loaded: false,
    loadingError: !invitationToken,
    confirmed: false,
    confirmationError: '',
    name: '',
    email: '',
    isUserActive: false,
    disabledForm: false,
  })

  useEffect(() => {
    if (!invitationToken) return
    apiRequest(loadInvitation, { invitationToken })
      .then(({ name, email } = {}) =>
        setState((s) => ({ ...s, loaded: true, name, email })),
      )
      .catch(() => setState((s) => ({ ...s, loadingError: true })))
    // eslint-disable-next-line react-hooks/exhaustive-deps, @eslint-react/x-exhaustive-deps, @eslint-react/exhaustive-deps
  }, [])

  const confirm = async ({
    password,
    passwordConfirmation,
    recaptchaResponse,
  }) => {
    setState((s) => ({ ...s, disabledForm: true }))
    try {
      const result = await apiRequest(confirmInvitation, {
        token: invitationToken,
        user_password: password,
        user_password_confirmation: passwordConfirmation,
        'g-recaptcha-response': recaptchaResponse,
      })
      setState((s) => ({
        ...s,
        confirmed: true,
        isUserActive: !!result?.active,
        disabledForm: false,
      }))
    } catch (error) {
      setState((s) => ({
        ...s,
        confirmationError: error.message,
        disabledForm: false,
      }))
    }
  }

  return { ...state, invitationToken, confirm }
}
